export default class GrayBackground {


	// Constructor
	constructor(asscroll, elements) {
		this.asscroll = asscroll;
		this.elements = elements;
		this.scroll = this.scroll.bind(this);

		const groups = [];
		let group = null;
		this.elements.forEach((element) => {
			if (group === null) {
				group = [];
				groups.push(group);
			}
			group.push(element);
			if (element.nextSibling && element.nextSibling.classList && element.nextSibling.classList.contains('background-is-gray') === false) {
				group = null;
			}
		});
		this.groups = groups;

	}


	// Public Methods
	destroy() {
		this.disable();
		delete this.asscroll;
		delete this.elements;
	}
	enable() {
		this.asscroll.on('update', this.scroll);
	}
	disable() {
		this.asscroll.off('update', this.scroll);
	}


	// Event Handlers
	scroll() {

		let bgIsGray = false;

		const windowHeight = window.innerHeight;
		const offset = (window.innerWidth < 768) ? windowHeight * 0.5 : windowHeight * 0.6;

		this.groups.forEach((group) => {
			let elementHeight = 0;
			group.forEach((element) => {
				elementHeight += element.offsetHeight
			});
			const { top } = group[0].getBoundingClientRect();
			const height = windowHeight - elementHeight;
			if (
				top >= height - offset && // before
				top - offset <= 0 // after
			) {
				bgIsGray = true;
			}
		});

		if (bgIsGray) {
			document.body.classList.add('bg-is-gray');
		} else {
			document.body.classList.remove('bg-is-gray');
		}

	}


}
